import React from 'react'
import './DashboardPage.css'; 

const DashboardPage = () => {
  return (
    <div className='dashboard'>
      <h2>Welcome to Dashboard</h2>
    </div>
  )
}

export default DashboardPage;
